import { render, staticRenderFns } from "./article-element.vue?vue&type=template&id=01d4cf8c&scoped=true&"
import script from "./article-element.vue?vue&type=script&lang=js&"
export * from "./article-element.vue?vue&type=script&lang=js&"
import style0 from "./article-element.vue?vue&type=style&index=0&id=01d4cf8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4cf8c",
  null
  
)

export default component.exports